<template lang="pug">
  v-flex 
    v-card
      v-card-title Operaciones
        v-spacer
        v-text-field(v-model='search' append-icon='fa-search' label='Buscar producto' single-line hide-details)
        v-dialog(v-model='dialog' max-width='500px')
          template(v-slot:activator='{ on }')
            v-btn.mb-2(color='primary' dark v-on='on' @click='cleanSelectedKey()') Añadir
          v-card
            v-card-title
              span.headline Añadir
            v-card-text
              v-form(autocomplete='false')
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex.sm12
                      v-text-field(v-model='$store.state.Operations.data.name' label='Comprobante de pago')
                    v-flex.sm12 
                      v-text-field(v-model='$store.state.Operations.data.code' type='number' label='Código')
                    v-switch(color='primary' v-model='$store.state.Operations.data.isInputCategory' label='Se utiliza en operaciones de entrada')
                    v-switch(color='primary' v-model='$store.state.Operations.data.isOutputCategory' label='Se utiliza en operaciones de salida')
                    v-switch(color='primary' v-model='$store.state.Operations.data.hasDestinationWarehouse' label='Tiene almacén de destino')
            v-card-actions
              v-spacer
              v-btn(color='primary' @click='close()') Cancelar
              v-btn(color='primary' @click='save()') Guardar
      v-data-table.elevation-1(:headers='headers' :items='record' :footer-props="footerProps" :search='search')
        template(v-slot:item.isInputCategory='{item}')
          v-icon(color='secondary' ) {{ item.isInputCategory ? 'far fa-check-square' : 'far fa-square'}}
        template(v-slot:item.isOutputCategory='{item}')
          v-icon(color='secondary' ) {{ item.isOutputCategory ? 'far fa-check-square' : 'far fa-square'}}
        template(v-slot:item.hasDestinationWarehouse='{item}')
          v-icon(color='secondary' ) {{ item.hasDestinationWarehouse ? 'far fa-check-square' : 'far fa-square'}}
        template(v-slot:item.action='{item}')
          v-btn(color='secondary' icon @click='editItem(item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(item.key)')
            v-icon(small) far fa-trash-alt
</template>

<script>
export default {
  data: () => ({
    search: '',
    dialog: false,
    headers: [
      {
        text: 'Tipo de recibo', align: 'left', value: 'name' },
      { text: 'Entrada', value: 'isInputCategory' },
      { text: 'Salida', value: 'isOutputCategory' },
      { text: 'Almacén de destino', value: 'hasDestinationWarehouse' },
      { text: '', value: 'action'}
    ],
    editedIndex: -1,
    footerProps: {
      'items-per-page-options':   [15, 30, 50]
    }
    }),
    methods: {
      editItem (key) {
      this.$store.dispatch('Operations/get',key)
      this.dialog = true
      },
      deleteItem (key) {
        this.$store.dispatch('Operations/clean',key)
      },
      close () {
        this.dialog = false
      },
      save () {
        this.$store.dispatch('Operations/add')
        this.close()
      },
      cleanSelectedKey(){
      this.$store.commit('Operations/cleanSelectedKey')
      },
    },
    computed: {
      record(){
        return this.$store.getters['Operations/record']
      }
    },
  }
</script>
